import React, { useEffect, useState } from 'react';
import { apiFetch } from '../../utils/api';
import UsersTable, { UsersTableUser } from './UsersTable';

interface Props {
  onOpenRisk: (userId: string) => void;
  onViewDetail: (userId: string, name: string, email: string) => void;
}

const DirectUsersTab: React.FC<Props> = ({ onOpenRisk, onViewDetail }) => {
  const [users, setUsers] = useState<UsersTableUser[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const data = await apiFetch<any>('/getUserData');
      const arr = Array.isArray(data) ? data : [];
      setUsers(arr.map((u: any) => ({
        id: String(u.id ?? ''),
        name: String(u.name ?? '—'),
        email: String(u.email ?? '—'),
        country: String(u.country ?? ''),
        phone: String(u.phone ?? ''),
        total_deposit_inr: Number(u.total_deposit_inr ?? u.total_deposit_usd ?? 0) || 0,
        total_withdrawal_inr: Number(u.total_withdrawal_inr ?? u.total_withdrawal_usd ?? 0) || 0,
        is_locked: u.is_locked === true || u.is_locked === 't',
        sports_betlocked: u.sports_betlocked === true || u.sports_betlocked === 't',
      })).reverse());
    } catch {
      setUsers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchUsers(); }, []);

  return (
    <UsersTable
      users={users}
      loading={loading}
      title="Direct Users"
      onRefresh={fetchUsers}
      onOpenRisk={onOpenRisk}
      onViewDetail={onViewDetail}
    />
  );
};

export default DirectUsersTab;
